import { state } from '@/shared/components/player/store';

export default {
  computed: {
    previousElement() {
      const previousElement = state.previousEpisode.id
        ? state.previousEpisode
        : state.previousRelatedProduct;

      return state.isEmbedded
        ? previousElement
        : {};
    },
  },
  methods: {
    playPreviousElement() {
      if (!state.isEmbedded) {
        return;
      }

      if (state.previousEpisode.id) {
        return this.playPreviousEpisode();
      }

      if (state.previousRelatedProduct.id) {
        return this.playPreviousRelatedProduct();
      }
    },
  },
};
